<app-header></app-header> 
<section class="inerpages-banner">
    <img src="assets/img/about-us-background.jpg" class="w-100" alt="">
    <div class="fade-bg"></div>
    <div class="mask-content-v-center text-center">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="tbox-iner text-center animate zoomIn" data-anim-type="zoomIn">
                        <div class="heading-iner">
                            <h2> {{ 'HOME.about_c1' | translate }}</h2>
                            <hr>
                            <p> {{ 'HOME.about_h1' | translate }} </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="about_sec1 mb-5 mb-md-0  about_part about_bg pb-0">
  <div class="container-fluid">
     <div class="row align-items-center">
        <div class="col-sm-4 col-lg-5 offset-lg-1">
           <div class="about_img rollIn">
              <img class="img-fluid" src="assets/img/logo-500x500.png" alt="">
          </div>
      </div>
      <div class="col-sm-8 col-lg-4">
       <div class="about_text dishes-text">
						<!-- <h5>About Us</h5>
						<h2>Sajway serves amazing Lebanese food.</h2>
						<h4>Our food quality is the best ever</h4> -->
                        <h3>{{ 'HOME.about_c1' | translate }}</h3>
                        <p>{{ 'HOME.about_c2' | translate }} </p>
                        <!-- <a href="#" class="btn m-read mt-3">Main Course <img src="assets/img/arrow-icon.png" alt=""></a> -->
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="dishes-area">
        <div class="container">
           
                                        <div class="row mb-5">
                                            <div class="col-lg-5 order-1 order-md-0 col-md-6 align-self-center">
                                                <!-- <h1 class="">01.</h1> -->
                                                <div class="dishes-text">
                                                    <h3>{{ 'HOME.innovation' | translate }}</h3>
                                                    <p class="pt-md-3">{{ 'HOME.about_c4' | translate }}.</p>
                                                 
                                                </div>
                                            </div>
                                            <div class="col-lg-5 order-0 order-md-1 offset-lg-2 col-md-6 align-self-center">
                                                <img src="assets/img/food-innovation.jpg" alt="" class="img-fluid mb-2">
                                            </div>
                                        </div>
                                        <div class="row mb-5">
                                            <div class="col-lg-5 my-md-5  col-md-6 mb-2 align-self-center">
                                                <img src="assets/img/expantion.jpg" alt="" class="img-fluid">
                                            </div>
                                            <div class="col-lg-5 my-md-5 offset-lg-2 col-md-6 align-self-center">
                                                <!-- <h1>02.</h1> -->
                                                <div class="dishes-text">
                                                    <h3> {{ 'HOME.about_c5' | translate }} </h3>
                                                    <p class="pt-md-3">{{ 'HOME.about_c6' | translate }}.</p>
                                                   <!--  <span class="style-change">$12.00</span>
                                                    <a href="#" class="btn m-read mt-3">Book a Table <img src="assets/img/arrow-icon.png" alt=""></a> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-5">
                                            <div class="col-lg-5 col-md-6 order-1 order-md-0 align-self-center">
                                                
                                                <div class="dishes-text">
                                                    <h3> {{ 'HOME.about_c7' | translate }} </h3>
                                                  <p class="pt-md-3">{{ 'HOME.about_c8' | translate }}.  </p>
                                                    <!-- <span class="style-change">$12.00</span>
                                                       <a href="#" class="btn m-read mt-3">Book a Table <img src="assets/img/arrow-icon.png" alt=""></a> -->
                                                   </div>
                                               </div>
                                               <div class="col-lg-5 offset-lg-2 order-0 order-md-1 mb-2 mb-md-0 col-md-6 align-self-center">
                                                <img src="assets/img/food-safety.jpg" alt="" class="img-fluid">
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                <section class="dishes-cont dishes-cou-bg mb-5 mb-md-0">
                                 <div class="container-fluid">
                                 
                                    <div class="row dishes-co-box no-gutters align-item-center">
                                        <div class="col-md-5 d-block mb-3 d-md-none co-box2 ">
                                            <img src="assets/img/gp-green-img.jpg" alt="" class="img-fluid w-100">
                                        </div>
                                       <div class="col-md-5 offset-md-7 co-box1">

                                          <!--   <h3 class="">we have two branches <br><span>in Abu Dhabhi</span></h3> -->
                                          <!-- <h4>Our food safety policy is strict and properly maintained,</h4> -->
                                          <h3 class="">{{ 'HOME.about_c9' | translate }}</h3>
                                          <p class="mt-2">{{ 'HOME.about_c10' | translate }}.</p>
                                      </div>
                                     
                                     </div>
                                 
                             </div>
                         </section>